import React, { ReactElement } from 'react';

import { Assets } from '../../../../../utils/assets';
import MaxWidth from '../../../../shared/MaxWidth';
import ButtonsBlock from '../ButtonsBlock';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {
  return (
    <S.Wrapper>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>The First Music Made for ADHD</S.Caption>
            <S.DescriptionContainer>
              <S.Description>
                Shown in peer-reviewed studies to increase focus brainwaves by 119% and improve sustained attention tasks in users with ADHD symptoms.
              </S.Description>
            </S.DescriptionContainer>
            <S.ButtonsWrapper>
              <ButtonsBlock />
            </S.ButtonsWrapper>
          </S.TextBox>
        </S.Content>
      </MaxWidth>
      <S.ImageWrapper>
        <S.Image alt={Assets.images.musicForAdhdHero.alt} src={Assets.images.musicForAdhdHero.url}/>
      </S.ImageWrapper>
    </S.Wrapper>
  );
};
